module.exports = __webpack_public_path__ + "assets/img/t4.bfb9d486.png";